import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import { reviewStatusSx, wrappingPillSx } from './palette';
import { statusDaysLabel, statusOf, statusTooltip } from './reviewLogic';
import type { CommandDeparture, CostBasis } from './types';

export default function ReviewStatusPill({
  departure,
  basis,
  today,
}: {
  departure: CommandDeparture;
  basis: CostBasis;
  today: string;
}) {
  const status = statusOf(departure, basis);
  if (!status) return null;
  const duration = statusDaysLabel(departure, basis, today);

  return (
    <Tooltip title={statusTooltip(departure, basis)}>
      <Chip
        size="small"
        label={duration ? `${status} · ${duration}` : status}
        color={
          status === 'Urgent'
            ? 'error'
            : status === 'Needs Action'
              ? 'warning'
              : status === 'On Track'
                ? 'success'
                : 'default'
        }
        sx={{
          ...reviewStatusSx(status),
          ...wrappingPillSx,
        }}
      />
    </Tooltip>
  );
}
